import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Helmet } from 'react-helmet';

import { store } from './state';

import CellList from './components/cell-list';

import 'bulmaswatch/superhero/bulmaswatch.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

const App = () => {
  return (
    <Provider store={store}>
      <Helmet>
        <title>JBook</title>
        <meta
          name="description"
          content="A jupyter-like book for javascript, supporting markdown, JS, JSX, CSS, and any NPM library."
        />
      </Helmet>
      <div>
        <CellList />
      </div>
    </Provider>
  );
};

ReactDOM.render(<App />, document.querySelector('#root'));
